import * as desktopElementActions from './desktopElementActions';
import * as mobileElementActions from './mobileElementActions';
import * as elementPropsActions from './elementPropsActions';
import * as elementLayoutActions from './elementLayoutActions';
import * as previewElementActions from './previewElementActions';
import * as generalActions from './generalActions';

export default {
  ...desktopElementActions,
  ...mobileElementActions,
  ...elementPropsActions,
  ...elementLayoutActions,
  ...previewElementActions,
  ...generalActions
};
